import { render, staticRenderFns } from "./BadgeTimeline.vue?vue&type=template&id=3cb842a8"
import script from "./BadgeTimeline.vue?vue&type=script&lang=js"
export * from "./BadgeTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports